function dynamicSort(property) {
  /* eslint-disable no-param-reassign, no-nested-ternary */
  let sortOrder = -1;
  if (property[0] === '-') {
    sortOrder = 1;
    property = property.substr(1);
  }
  return function sort(a, b) {
    const result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
  /* eslint-enable no-param-reassign, no-nested-ternary */
}

export default dynamicSort;



// WEBPACK FOOTER //
// ./app/utils/dynamicSort.js